// Developer Flags
export const LOG_WS_EVENTS = false;

export const USE_ZOOM_UI_TOOLKIT = false;
export const LOG_VIDEO_STATS = false;

// Video Provider Flags
export const USE_TWILIO_VIDEO = true;
